import { Controller } from '@hotwired/stimulus';
import { useWindowResize } from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static values = {
    index: {
      type: Number,
      default: 0,
    },
  };

  static targets = ['tab', 'tabPanel'];

  connect() {
    useWindowResize(this);
  }

  windowResize() {
    this.showTab();
  }

  change(e) {
    const parentElement = (e.currentTarget)?.parentElement;
    if (!parentElement) {
      return;
    }
    this.indexValue = Array.from(parentElement.children)
      .filter(item => !(item instanceof HTMLSpanElement)) // skip span elements (if any)
      .findIndex(item => item === e.currentTarget);
  }

  indexValueChanged() {
    this.showTab();
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.tabPanelTargets[index];
      tab.classList.toggle('is-active', index === this.indexValue);
      tab.setAttribute('aria-selected', index === this.indexValue);
      panel.classList.toggle('is-hidden', index !== this.indexValue);
    });
  }
}
